/***********************
 * NODE CHART TEMPERATURE (HISTORY)
 * (+ IMPORT PDF/XLSX)
 ************************/

import React, { useEffect, useState } from "react"
import ReactApexChart from "react-apexcharts"
import PropTypes from "prop-types"
import { Col, Row } from "reactstrap"
import { Link } from "react-router-dom"

//Translation
import { withTranslation } from "react-i18next"
import { initLanguage, localesApexChart } from "common/languagesApexCharts"
import { historyToolsDownloadZoom } from "components/Charts/chartTools"

const NodeChartTempHistory = props => {
  const [chartDataTempAvg, setChartDataTempAvg] = useState(["", 0])
  const [chartDataTempMin, setChartDataTempMin] = useState(["", 0])
  const [chartDataTempMax, setChartDataTempMax] = useState(["", 0])
  const [language, setLanguage] = useState("fi")

  // Loading state
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (props.showLoading != undefined) setIsLoading(props.showLoading)
  }, [props.showLoading])

  useEffect(() => {
    if (props.data != undefined) {
      setChartDataTempAvg(props.data[0])
      setChartDataTempMin(props.data[1])
      setChartDataTempMax(props.data[2])
    }
  }, [props.data])

  // Init language
  useEffect(() => {
    setLanguage(initLanguage)
  }, [])

  const series = [
    {
      name: props.t("Average temperature"),
      type: "line",
      data: chartDataTempAvg,
    },
    {
      name: props.t("Min temperature"),
      type: "line",
      data: chartDataTempMin,
    },
    {
      name: props.t("Max temperature"),
      type: "line",
      data: chartDataTempMax,
    },
  ]
  const options = {
    chart: {
      id: "node-temp-chart",
      locales: localesApexChart,
      defaultLocale: language,
      dropShadow: {
        enabled: !0,
        color: "#000",
        top: 18,
        left: 7,
        blur: 8,
        opacity: 0.1,
      },
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: historyToolsDownloadZoom,
        export: {
          csv: {
            filename: undefined,
            columnDelimiter: " ",
            headerCategory: "category",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString()
            },
          },
          svg: {
            filename: undefined,
          },
          png: {
            filename: undefined,
          },
        },
        autoSelected: "zoom",
      },
    },
    stroke: {
      width: [3, 1, 1],
      curve: "smooth",
    },
    colors: ["#ff954e", "#fcda69", "#ff4c2c"],
    xaxis: {
      type: "datetime",
      labels: {
        datetimeUTC: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (y !== undefined) {
            return y.toFixed(0) + " " + props.t("°C")
          }
          return y
        },
      },
      x: {
        format: "dd.MM.yyyy",
      },
    },
  }

  return (
    <div>
      {isLoading ? (
        <Row>
          <Col xs="12">
            <div className="text-center my-3">
              <Link to="#" className="text-primary">
                <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                {props.t("Loading")}
              </Link>
            </div>
          </Col>
        </Row>
      ) : (
        <div>
          <Row>
            <div id="line-chart" dir="ltr">
              <ReactApexChart
                options={options}
                series={series}
                type="line"
                height="300"
              />
            </div>
          </Row>
        </div>
      )}
    </div>
  )
}

NodeChartTempHistory.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
  showLoading: PropTypes.bool,
}

export default withTranslation()(NodeChartTempHistory)
